import { cn } from "@/lib/utils";

type Props = {
  className?: string;
};

/* The template's blurred ground, in the dose indigo instead of a brand hue. */
export function BackgroundBlur({ className }: Props) {
  return (
    <div
      className={cn("pointer-events-none absolute top-0 left-0 -z-10 h-full w-full overflow-hidden", className)}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-[#dedcf8]/60 via-[#e8e7fa]/30 to-transparent" />
      <div
        className="absolute top-0 left-1/2 h-[500px] w-[800px] -translate-x-1/2 rounded-full blur-3xl"
        style={{
          background:
            "radial-gradient(circle, rgba(75,69,214,0.20) 0%, rgba(222,220,248,0.15) 50%, transparent 100%)",
        }}
      />
    </div>
  );
}

export function FooterBlur({ className }: Props) {
  return (
    <div
      className={cn("pointer-events-none absolute bottom-0 left-0 -z-10 h-full w-full overflow-hidden", className)}
    >
      <div className="absolute inset-0 bg-gradient-to-t from-[#dedcf8]/60 via-[#e8e7fa]/30 to-transparent mask-t-from-90%" />
      <div
        className="absolute bottom-0 left-1/2 h-[400px] w-[600px] -translate-x-1/2 rounded-full blur-3xl"
        style={{
          background:
            "radial-gradient(circle, rgba(75,69,214,0.16) 0%, rgba(222,220,248,0.12) 50%, transparent 100%)",
        }}
      />
    </div>
  );
}
